function type(x) {
  return Object.prototype.toString.call(x).slice(8, -1);
}

function getEls(selector, ctx = document) {
  return Array.from(ctx.querySelectorAll(selector));
}

function each(list, fn) {
  if (Array.isArray(list)) {
    for (let i = 0; i < list.length; i++) {
      fn(list[i], i);
    }
    return;
  }
  throw new Error(`Unable to iterate over "${type(list)}". NOT IMPLEMENTED`);
}

const elementsCache = new WeakMap();

function createOnRootHandler() {
  let _state = {};

  return (e) => {
    _state = {};

    const detail = e.detail;
    if (!detail) return;

    const { target, sibling } = detail;
    if (!target) return;

    if (target._currentController) {
      target._currentController.abort();
    }

    const klass =
      target._instance === undefined
        ? (target._instance =
            window.customElements.get(target.localName) ?? null)
        : target._instance;

    let els = elementsCache.get(target);
    if (!els) {
      const section = target.closest(['[data-section-type="product"]']);
      const sectionUid = section.getAttribute("data-section-uid");
      let quotePopupContent = sectionUid
        ? document.querySelector(
            `[data-content-for-section="${sectionUid}"] .gq-form-container`
          )
        : null;

      if (quotePopupContent) {
        quotePopupContent = {
          section: quotePopupContent,
          productUrl: quotePopupContent.querySelector("[data-product-url]"),
          productAdminUrl: quotePopupContent.querySelector(
            "[data-product-admin-url]"
          ),
          variantSku: quotePopupContent.querySelector("[data-variant-sku]"),
        };
      }

      const title = getEls(".product-single__title", section);
      const fitmentWidget = getEls("x-ymm-filter.YMM_Ftmnt", section);
      const variantId = getEls(
        "form[action^='\\/cart\\/add'] [name='id']",
        section
      );

      const blockPrice = getEls(".product-block--price", section);
      const blockSalesPoint = getEls(".product-block--sales-point", section);
      const productImages = getEls("[data-product-images]", section);
      const blockFitment = getEls(".product__fitment-list", section);

      // const regularPrice = getEls("[data-product-price]", section);
      // const comparePrice = getEls("[data-compare-price]", section);

      els = {
        section,
        title,
        fitmentWidget,
        variantId,
        quotePopupContent,

        blockPrice,
        blockSalesPoint,
        productImages,
        blockFitment,
      };
      elementsCache.set(target, els);
    }

    each(els.title, (el) => {
      el.textContent = sibling.product.title;
    });
    each(els.fitmentWidget, (fitmentWidget) => {
      if ("fits" in fitmentWidget && Array.isArray(sibling.options.fitment)) {
        fitmentWidget.fits = sibling.options.fitment;
      }
    });
    each(els.productImages, (el) => {
      el.style.opacity = "0.7";
    });
    const defaultVariantId = sibling.product.variants[0].id;
    each(els.variantId, (el) => {
      if (el.nodeName === "SELECT") {
        el.options.length = 1;
        el.options[0].value = defaultVariantId;
      }

      el.value = defaultVariantId;
    });

    if (els.quotePopupContent) {
      if (els.quotePopupContent.productUrl) {
        els.quotePopupContent.productUrl.value = `Quote for: ${window.location.origin}/products/${sibling.product.handle}?variant=${defaultVariantId}`;
      }

      if (els.quotePopupContent.productAdminUrl) {
        els.quotePopupContent.productAdminUrl.value = `https://admin.shopify.com/store/${
          Shopify.shop.split(".")[0]
        }/products/${sibling.product.id}`;
      }
      if (els.quotePopupContent.variantSku) {
        els.quotePopupContent.variantSku.value =
          sibling.product.variants[0].sku;
      }
    }

    target._currentController = new AbortController();
    let current = _state;
    klass
      .fetchHtml(
        `/products/${sibling.product.handle}?section_id=${target.attrs.sectionId}`
        // {
        //   signal: target._currentController.signal,
        // }
      )
      .then((nextDoc) => {
        if (current !== _state) {
          console.log("Promise not matched... for ", sibling.product.title);
          return;
        }

        const nextblockPrice = getEls(".product-block--price", nextDoc).map(
          (x) => x.cloneNode(true)
        );
        each(els.blockPrice, (prev, i) => {
          prev.replaceWith(nextblockPrice[i]);
        });
        els.blockPrice = nextblockPrice;

        const nextblockSalesPoint = getEls(
          ".product-block--sales-point",
          nextDoc
        ).map((x) => x.cloneNode(true));
        each(els.blockSalesPoint, (prev, i) => {
          prev.replaceWith(nextblockSalesPoint[i]);
        });
        els.blockSalesPoint = nextblockSalesPoint;

        const nextProductImages = getEls("[data-product-images]", nextDoc).map(
          (x) => x.cloneNode(true)
        );
        each(els.productImages, (prev, i) => {
          prev.replaceWith(nextProductImages[i]);
        });
        els.productImages = nextProductImages;

        [
          "imageContainer",
          "productImageMain",
          "mainSlider",
          "thumbSlider",
          "thumbScroller",
          ,
          "photoThumbs",
        ].forEach((key) => {
          els.section._Product.cache[key] = nextProductImages[0].querySelector(
            els.section._Product.selectors[key]
          );
        });
        els.section._Product.initProductSlider(sibling.product.variants[0]);
        els.section._Product.initImageZoom();
        if (window.AOS) {AOS.refreshHard()}

        const nextblockFitment = getEls(".product__fitment-list", nextDoc).map(
          (x) => x.cloneNode(true)
        );
        each(els.blockFitment, (prev, i) => {
          prev.replaceWith(nextblockFitment[i]);
        });
        els.blockFitment = nextblockFitment;

        if (els.quotePopupContent) {
          if (els.quotePopupContent.section) {
            const secondStep = els.quotePopupContent.section.querySelector(
              '.form-step[data-step="1"]'
            );
            const nextSecondStep = nextDoc.querySelector(
              '.gq-form-container .form-step[data-step="1"]'
            );
            if (secondStep && nextSecondStep) {
              secondStep.innerHTML = nextSecondStep.innerHTML;
            }
          }
        }
      })
      .catch((e) => {
        if (e.name === "AbortError") {
          // Request was aborted, handle it if needed
          console.log("Request was aborted");
        } else {
          // Handle other errors
          console.error("Error while fetching product HTML:", e);
        }
      })
      .finally(() => {
        target._currentController = null;
      });

    console.log("ROOT =>", detail);
  };
}

document.addEventListener("x-product-siblings:root", createOnRootHandler());

// set product page title
document.addEventListener("x-ymm-filter:loaded", (e) => {
  const detail = e.detail;
  if (!detail) return;
  const ymmEl = detail.element;
  let title = detail.title;

  const titleEl = document.querySelector(
    '[data-ymm-filter-applied="true"] .shopify-section.collection-header .section-header__title'
  );

  if (titleEl) {
    titleEl.textContent = title;
    document.body.setAttribute("data-ymm-filter-title-applied", "true");
  }
});

;(() => {
  const sp = new URLSearchParams(window.location.search);
  const filters = {
    make: sp.get("filter.p.m.custom.fitment_list_makes"),
    model: sp.get("filter.p.m.custom.fitment_list_models"),
  };

  function setSortAfterLoad(ymmEl) {
    if (filters.make) {
      localStorage.setItem(`ymm_filter:make`, filters.make);
      const sortOrder = "1,2,0,3";
      ymmEl.ymm_sort = sortOrder;
      localStorage.setItem("ymm-sort-settings", sortOrder);

      if (!filters.model) {
        localStorage.removeItem(`ymm_filter:model`);
      }

      localStorage.removeItem(`ymm_filter:year`);
      localStorage.removeItem(`ymm_filter:trim`);
    }

    if (filters.model) {
      localStorage.setItem(`ymm_filter:model`, filters.model);
    }
  }

  const ymmEls = [];

  function applySortOrder(ymm_sort) {
    ymmEls.forEach((ymmEl) => {
      manuallyHydrating = true;
      ymmEl.hydrate({ ymm_sort });
      manuallyHydrating = false;
    });
  }

  let savedSortOrder = localStorage.getItem("ymm-sort-settings");
  if (savedSortOrder) savedSortOrder = savedSortOrder.split(",");
  if (savedSortOrder && !savedSortOrder.length) savedSortOrder = null;

  document.addEventListener("x-ymm-filter:loading", (e) => {
    console.log(`x-ymm-filter:loading | manuallyHydrating?`, manuallyHydrating);

    const target = e.detail.element;
    if (!target) return;

    if (!ymmEls.includes(target)) {
      ymmEls.push(target);
    }

    if (savedSortOrder) {
      target.ymm_sort = savedSortOrder;
      setSortAfterLoad(target);
    }
  });

  // -------------------------------------------
  // -------------------------------------------

  let Sortable = null;
  function importSortable(cb) {
    if (Sortable) return cb(Sortable);
    const script = document.createElement("script");
    script.src = "https://www.unpkg.com/sortablejs@1.15.2/Sortable.min.js";
    document.head.appendChild(script);
    script.onload = () => {
      Sortable = window.Sortable;
      cb(window.Sortable);
    };
  }

  // js--reset-ymm-sort
  let manuallyHydrating = false;
  let sortableInstance = null;

  document.addEventListener("click", (e) => {
    const target = e.target;
    if (
      target instanceof HTMLElement &&
      target.hasAttribute("data-ymm-sort-settings-trigger")
    ) {
      importSortable((Sortable) => {
        const sortableListEl = document.getElementById(
          "ymm-sort-settings-popup-items"
        );

        if (!sortableInstance) {
          sortableInstance = Sortable.create(sortableListEl, {
            dataIdAttr: "data-id",
            onEnd(evt) {
              savedSortOrder = sortableInstance.toArray();

              localStorage.setItem(
                "ymm-sort-settings",
                savedSortOrder.join(",")
              );

              applySortOrder(savedSortOrder);
            },
          });
          sortableListEl.setAttribute("hydrated", "true");
        }

        if (savedSortOrder) {
          sortableInstance.sort(savedSortOrder, true);
        }
      });
    }
  });

  document.addEventListener("set_ymm_sort", (e) => {
    const order = e.detail.ymm_sort;
    if (Array.isArray(order)) order = order.join(",");
    if (!order) return;

    savedSortOrder = order;
    localStorage.setItem("ymm-sort-settings", order);
    if (sortableInstance) {
      applySortOrder(order);
      sortableInstance.sort(savedSortOrder.split(","), true);
    }
  });
})();